import axios from 'axios';
import { Modal } from 'bootstrap';
import { route } from 'ziggy-js';

export class Variant {
    constructor(elements) {
        if (elements.length) {
            let $this = this;

            $.each(elements, function (index, element) {
                element.onclick = async event => {
                    event.preventDefault();

                    const { data } = await $this.getVariantModal(element);

                    document.querySelector('#variant-modal').innerHTML = data;

                    const modal = new Modal(document.querySelector('#variant-modal'));

                    modal.show();

                    const amounts = document.querySelector('#amounts');

                    if (amounts) {
                        const contents = amounts.querySelectorAll('tr');

                        if (contents.length === 0) {
                            amounts.remove();
                        }
                    }
                };
            });
        }
    }

    async getVariantModal(element) {
        const { modelNo, colorNo, size } = element.dataset;

        return await axios.get(route('catalog.variant-modal', { modelNo, colorNo, size }));
    }
}
